import { Typography } from '@mui/material'
import React, { ComponentPropsWithoutRef } from 'react'

interface FieldLabelProps extends ComponentPropsWithoutRef<'div'> {
  required?: boolean
  sx?: any
}
export function FieldLabel({ sx = {}, children, required }: FieldLabelProps) {
  return (
    <Typography variant="body1" fontWeight="bold" marginBottom={1} sx={sx}>
      {children}
      {required && (
        <Typography color="error" variant="caption" fontWeight="bold" sx={{ fontSize: '110%' }}>
          *
        </Typography>
      )}
    </Typography>
  )
}

FieldLabel.defaultProps = {
  required: false,
}
